import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

export const PasswordInput = ({ id, testid, value, onChange, className = "", minLength, required = true }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input
        id={id}
        type={show ? "text" : "password"}
        required={required}
        minLength={minLength}
        data-testid={testid}
        value={value}
        onChange={onChange}
        className={`${className} pr-8`}
      />
      <button
        type="button"
        data-testid={`${testid}-toggle`}
        onClick={() => setShow((s) => !s)}
        aria-label={show ? "Masquer le mot de passe" : "Afficher le mot de passe"}
        className="absolute right-0 top-1/2 -translate-y-1/2 p-1 text-ink/35 transition-colors duration-300 hover:text-bronze"
      >
        {show ? <EyeOff size={15} strokeWidth={1.5} /> : <Eye size={15} strokeWidth={1.5} />}
      </button>
    </div>
  );
};
